import log from 'loglevel';

export function createTypedLogger(type: string) {
  return {
    info: (msg: any, meta: Record<string, any> = {}) =>
      log.info(msg, { ...meta, type }),
    warn: (msg: any, meta: Record<string, any> = {}) =>
      log.warn(msg, { ...meta, type }),
    error: (msg: any, meta: Record<string, any> = {}) =>
      log.error(msg, { ...meta, type }),
    debug: (msg: any, meta: Record<string, any> = {}) =>
      log.debug(msg, { ...meta, type }),
  };
}
